import React from 'react';
import PropTypes from 'prop-types';
import { FormattedMessage } from 'react-intl';
import { PackageBadges } from '..';
import css from './InquiryPriceIncludes.module.css';

const InquiryPriceIncludes = ({ packageInfo, listing }) => {
  // Only render if we have a package
  if (!packageInfo) {
    return null;
  }

  return (
    <div className={css.priceIncludes}>
      <div className={css.priceIncludesHeading}>
        <FormattedMessage id="InquiryWizard.priceIncludes" />
      </div>
      <PackageBadges packageInfo={packageInfo} listing={listing} />
    </div>
  );
};

InquiryPriceIncludes.propTypes = {
  packageInfo: PropTypes.object.isRequired,
  listing: PropTypes.object,
};

InquiryPriceIncludes.defaultProps = {
  listing: null,
};

export default InquiryPriceIncludes;
